import { ChangeDetectionStrategy, Component, computed, ElementRef, HostListener, inject, signal } from "@angular/core";
import { TranslationService } from "@kernel/translations/translation.service";
import { CUSTOMER_LANGUAGES, ILanguageOption } from "@shared-core/general/queue/configs/languages.config";

@Component({
  selector: "app-language-switcher",
  standalone: true,
  templateUrl: "./language-switcher.component.html",
  styleUrl: "./language-switcher.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent {
  private readonly translation = inject(TranslationService);
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly languages = CUSTOMER_LANGUAGES;
  readonly currentLang = this.translation.currentLang;

  readonly currentCode = computed(() => (this.currentLang() ?? "en").toUpperCase());

  readonly open = signal(false);

  toggle(): void {
    this.open.update(v => !v);
  }

  isActive(lang: ILanguageOption): boolean {
    return this.currentLang() === lang.code;
  }

  selectLang(lang: ILanguageOption): void {
    this.translation.saveUserLang(lang.code);
    this.open.set(false);
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (!this.open()) return;
    if (!this.host.nativeElement.contains(event.target as Node)) {
      this.open.set(false);
    }
  }

  @HostListener("document:keydown.escape")
  onEscape(): void {
    if (this.open()) this.open.set(false);
  }
}
